import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import actions from 'yoda-site-components/lib/actions/ProductCartridgeAction';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import _get from 'lodash/get';
import { bindActionCreators } from 'redux';
import getBreadCrumbInfo from '../../selectors/BreadCrumbs';
import { getCategoryNID } from '../../utils';

export class Certona extends Component {
    static defaultProps = {
        breadCrumbInfo: [],
        deviceType: {
            isDesktop: false,
            isMobile: false,
            isTablet: false,
        },
        enableRefreshCertona: false,
        organicData: false,
        page: '',
        products: [],
        reRenderCertona: false,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        iOSScrollTimeoutForBlankPage: PropTypes.number.isRequired,
        breadCrumbInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        enableRefreshCertona: PropTypes.bool,
        organicData: PropTypes.bool, // eslint-disable-line
        page: PropTypes.string,
        products: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        reRenderCertona: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.timerID = null;
    }

    /* istanbul ignore next */
    componentDidMount() {
        const { iOSScrollTimeoutForBlankPage } = this.props;
        /* YODATOF-917 - on IOS 13.6.0 greater version few times when coming back from PDP
            page is going blank here dom is creating but not painting .. following code been added to fix this
        */
        if (Utils.findMobileOS() === 'iOS' && !__SERVER__) {
            this.timerID = setInterval(() => {
                window.scroll();
            }, iOSScrollTimeoutForBlankPage);
        }
    }

    // As we dont have a state/props which gets updated - Returning false always
    /* istanbul ignore next */
    shouldComponentUpdate(nextProps) {
        if (nextProps.organicData) {
            return true;
        }

        if (
            nextProps.reRenderCertona &&
            nextProps.products !== this.props.products &&
            this.props.enableRefreshCertona
        ) {
            const { cartridge1 } = this;
            cartridge1 && this.props.actions.removeProductCartridgeSlot(cartridge1);
            return true;
        }

        return false;
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        if (this.timerID) {
            clearInterval(this.timerID);
        }
    }

    getOrganicSkus() {
        const { products } = this.props;
        let skus = '';
        for (let i = 0; i < 10 && products[i]; i += 1) {
            skus += `${products[i].ppId};`;
        }
        return skus.slice(0, -1);
    }

    getRecZoneAttr(page) {
        let slotDetails;
        const { reRenderCertona } = this.props;
        if (page.indexOf('galleryRecZones') !== -1) {
            const { breadCrumbInfo } = this.props;
            slotDetails = {
                pageType: 'CATEGORY',
                attributes: {
                    recommendations: true,
                    categoryid: getCategoryNID(),
                    itemid: this.getOrganicSkus(),
                },
                loader: 'certona',
            };
            breadCrumbInfo.forEach((breadCrumb) => {
                if (breadCrumb.catId) {
                    slotDetails.attributes.categoryid = breadCrumb.catId;
                }
                if (breadCrumb.deptId) {
                    slotDetails.attributes.departmentid = breadCrumb.deptId;
                }
                if (breadCrumb.deptName) {
                    slotDetails.attributes.departmentname = breadCrumb.deptName;
                }
            }, this);
            this.cartridge1 = reRenderCertona ? 'category4_rr' : 'category1_rr';
            this.cartridge2 = 'category2_rr';
            /* istanbul ignore else */
        } else if (page.indexOf('searchRecZones') !== -1) {
            slotDetails = {
                pageType: 'SEARCH',
                attributes: {
                    recommendations: true,
                    itemid: this.getOrganicSkus(),
                },
                loader: 'certona',
            };
            this.cartridge1 = reRenderCertona ? 'search4_rr' : 'search1_rr';
            this.cartridge2 = 'search2_rr';
        }
        return slotDetails;
    }

    getRefreshCertona = (page) => {
        switch (page) {
            case 'CATEGORY':
                return window.certonaExposeCategory;
            case 'SEARCH':
                return window.certonaExposeSearch;
            default:
                // do nothing;
                return null;
        }
    };

    render() {
        const { page, reRenderCertona, products, deviceType } = this.props;
        const slotDetails = products && products.length ? this.getRecZoneAttr(page) : '';
        const { cartridge1, cartridge2 } = this;
        const refreshCertona = reRenderCertona
            ? this.getRefreshCertona(slotDetails.pageType)
            : null;
        /* istanbul ignore next */
        if (slotDetails && cartridge1 && cartridge2) {
            return (
                <div className="mb-2">
                    <CertonaZone
                        page={slotDetails.pageType}
                        slotDetails={{ ...slotDetails, slotId: cartridge1 }}
                        schemasToRender={cartridge1}
                        refreshCertona={refreshCertona}
                        showLoader={false}
                        disableLazyLoad={!deviceType.isDesktop}
                        wrapperClass="mb-2"
                    />
                    <CertonaZone
                        page={slotDetails.pageType}
                        slotDetails={{ ...slotDetails, slotId: cartridge2 }}
                        schemasToRender={cartridge2}
                        showLoader={false}
                        disableLazyLoad={!deviceType.isDesktop}
                    />
                </div>
            );
        }
        return null;
    }
}

export const mapStateToProps = (store) => ({
    breadCrumbInfo: getBreadCrumbInfo(store),
    products: store.products || [],
    organicData: store.commonData.gallery,
    reRenderCertona: store.renderCertona && store.renderCertona.reRenderCertona,
    enableRefreshCertona:
        store.context.featureFlags && store.context.featureFlags.enableRefreshCertona,
    deviceType: store.context.deviceType,
    iOSScrollTimeoutForBlankPage: _get(
        store,
        'context.preferences.iOSScrollTimeoutForBlankPage',
        100
    ),
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Certona);
